<template>

  <div class="footer">
    <div class="footer-content">
      <el-image :src="osredmLogo" class="osredm-logo"></el-image>
      <div class="text">
        <div>
          <i class="icon-zqldianhuahover"></i>&nbsp; +86-010-66357650 &nbsp;&nbsp;&nbsp;&nbsp;
          <i class="icon-zqlfasongyoujian"></i>&nbsp; osredm@163.com &nbsp;&nbsp;&nbsp;&nbsp;
          <i class="icon-zqlweizhi1"></i>&nbsp; 北京市海淀区西三环北路72号
        </div>
        <div style="margin-top: 10px">
          版权所有：<a href="https://osredm.com/">红山开源社区</a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802034576" style="margin-left: 10px">
            <img :src="policeLogo" style="width: 15px;border-radius: 10px;margin-right: 3px">
            京公网安备 11010802034576 号
          </a>
          <a href="https://beian.miit.gov.cn/#/Integrated/index" style="margin-left: 10px">
            京ICP备2021005060-1
          </a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",

  data(){

    return{
      policeLogo: require("@/assets/logo/police.png"),
     osredmLogo: require("@/assets/logo/osredmLogo-white.svg"),
    }

  },
  
}
</script>


<style src="@/assets/css/Footer.css" scoped>

</style>